import React, { useEffect } from 'react';
import SalesOrderForm from '../../Components/Form/SalesOrderForm/SalesOrderForm';
import FormLayout from '../../Components/Layout/FormLayout';
import { SalesOrderIcon } from '../../Assets/Navigation/NavigationIcons';
import { useLocation } from 'react-router-dom';
import { getObjFromLS } from '../../Helpers';
import { useTranslation } from 'react-i18next';

const AddSalesOrder = ({ handleToast }) => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('saleOrder.add_sales_order');
    // document.title =  'Add Sales Orders';
  }, []);

  const handleRedirection = () => {
    const { search = '' } = location;
    let dataFromLS = getObjFromLS('module');
    if (dataFromLS.moduleName === 'contacts' && search) return '/contacts';
    else return '/salesorders';
  };

  return (
    <FormLayout
      Icon={SalesOrderIcon}
      // closeUrl="/salesorders"
      closeUrl={handleRedirection()}
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
      title={t('saleOrder.create_sales_orders')}
    >
      <SalesOrderForm type="add" handleToast={handleToast} />
    </FormLayout>
  );
};

export default AddSalesOrder;
